import AuthFactory from '@/factories/AuthFactory';
import AuthRepository from '@/repositories/AuthRepository';
import IUserInfo from '@/types/IUserInfo';
import store from '@/store/index';
import IUserForm from '@/types/IUserForm';

export default class UserService {
  static async getCurrentUser(): Promise<void> {
    const user: IUserInfo = await AuthFactory.toUserInfo(await AuthRepository.getUserInfo())
    const isLoggedAs = user.role === 'ADMIN_AS_USER' && user.permissions.includes('admin.logout_as')
    store.commit('user/setIsLoggedAs', isLoggedAs)
    store.commit('user/setUser', user)
    // store.commit('user/setIsLoggedAs', getLocalStorage('isLoggedAs') === true || false)
  }

  static setUser(user: IUserInfo) {
    store.commit('user/setUser', user)
  }

  static updateUser(user: IUserForm) {
    return AuthRepository.updateUser(user)
  }
}
